import { notEmpty } from '@/typings/array';

export const capitalize = ([first, ...rest]: string) =>
  `${first.toUpperCase()}${rest.join('')}`;

export const initials = (text: string) =>
  text
    .split(' ')
    .filter(notEmpty)
    .map((word) => word[0].toUpperCase())
    .join('');

export const formatUrl = (url: string) => {
  if (url.match(/^https?:\/\//)) return url;
  if (url.match(/^mailto:/i)) return url;

  return `https://${url}`;
};

export const toCamel = (s: string): string => {
  return s.replace(/([-_][a-z0-9])/gi, ($1) => {
    return $1.toUpperCase().replace(/[-_]/, '');
  });
};
